var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"show-time":"","allowClear":""},on:{"change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }